import React, {useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {MessageAlert} from '../../utils';
import {
  DiscordClipFeatureDescription,
  DiscordIntegrationClipEnabledFeatureDescription,
  DiscordIntegrationFeatureDescription,
} from '../../../../system/FeatureDescriptionModal';
import {UpdateChanelInput} from '../../../../system/UpdateChannelModal';

export const DiscordIntegration = ({
  onConfigUpdate,
  validateAndGet,
  configuration,
}) => {
  const [urlError, setUrlError] = useState(undefined);

  const [messageError, setMessageError] = useState(undefined);

  useEffect(() => {
    validateAndGet(() => {
      let isValid = true;

      if (configuration.url === undefined) {
        setUrlError('Url should not be empty');
        isValid = false;
      } else if (!configuration.url.includes('discord')) {
        setUrlError('Not a valid discord web hook url');
        isValid = false;
      }

      if (configuration.message === undefined) {
        setMessageError('Message should not be empty');
        isValid = false;
      } else if (!configuration.message.includes('{{HEART_RATE}}')) {
        setMessageError('Message should contain {{HEART_RATE}} placeholder');
        isValid = false;
      }

      return isValid;
    });
    // eslint-disable-next-line
  }, [configuration]);

  return (
    <>
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Webhook Url {<DiscordIntegrationFeatureDescription />}
        </Form.Label>
        <Col sm="3">
          <Form.Control
            as="input"
            value={configuration.url}
            onChange={(e) => {
              onConfigUpdate({...configuration, url: e.target.value});
              setUrlError(undefined);
            }}
          />
        </Col>
      </Form.Group>
      <MessageAlert message={urlError} />
      <Form.Group as={Row}>
        <Col>
          <Row>
            <Form.Label column sm="2">
              Clip enabled {<DiscordIntegrationClipEnabledFeatureDescription />}
            </Form.Label>
            <Col sm="auto">
              <Form.Check
                type="checkbox"
                onChange={(e) => {
                  let clipEnabled = !configuration.clipEnabled;
                  onConfigUpdate({
                    ...configuration,
                    clipEnabled,
                    message: clipEnabled
                      ? configuration.message + ' {{CLIP_URL}}'
                      : configuration.message.replaceAll('{{CLIP_URL}}', ''),
                  });
                }}
                checked={configuration.clipEnabled}
              />
            </Col>
          </Row>

          {configuration.clipEnabled && (
            <Row>
              <Col>
                <div style={{color: '#11a2b1'}}>
                  Clip will be automatically created only if Clip creation
                  permissions in your channel settings are not limited only to
                  followers or subscribers
                </div>
                <div className={'text-muted'}>
                  Note: Discord notification with clip has 20-30 seconds delay.
                  This delay is needed for Twitch to create a clip.
                </div>
              </Col>
            </Row>
          )}
        </Col>
      </Form.Group>
      {configuration.clipEnabled && (
        <>
          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Edit channel {<DiscordClipFeatureDescription />}
            </Form.Label>
            <UpdateChanelInput />
          </Form.Group>
        </>
      )}
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Message
        </Form.Label>
        <Col sm="3">
          <Form.Control
            as="textarea"
            rows={3}
            value={configuration.message}
            onChange={(e) => {
              onConfigUpdate({...configuration, message: e.target.value});
              setMessageError(undefined);
            }}
          />
        </Col>
      </Form.Group>

      <MessageAlert message={messageError} />
    </>
  );
};
